import store from "../../../store";
import _map from "lodash/map";
import _toUpper from "lodash/toUpper";
import { Money } from "@core/store/types/common";

export function filterByAvailableCurrencies (array: Money[]) {
  const availableCurrencies: string[] = _map(store.state.auth.availableCurrencies, _toUpper);
  return array?.filter(({ currency }) => availableCurrencies.includes(_toUpper(currency)));
}